export default {
 footer: {
     ageRestriction: "본 플랫폼은 18세 이상의 이용자만 이용할 수 있습니다. 도박은 중독될 수 있습니다. 책임감 있게 오직 오락 목적으로만 즐겨주시기 바랍니다. 자세한 내용은 책임감 있는 게임 페이지를 방문하십시오.",
     followUs: "팔로우 하기",
     company: "회사 소개",
     legal: "법적 고지",
     support: "고객 지원",
     gameProviders: "게임 제공업체",
     copyright: "Copyright © 2019-2026 LOGO. All Rights Reserved.",
	 documents: "문서",
   }
}
